<template>
<v-content class="spinelab-website-front">
  <v-container v-if="initiated">
    <v-flex xs12 sm12 md12>
      <h1 class="text-sm-left">お問合せの管理</h1>
    </v-flex>
    <v-tabs
       centered
       v-model="tab"
       >
      <v-tab href="#tab-history">お問合せ履歴</v-tab>
      <v-tab href="#tab-settings">設定</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item id="tab-history">
        <template v-if="selectedContact">
          <v-list>
            <v-list-tile v-for="ci in contactItems" :key="ci.id">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ci.m_contact_item.key}}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{selectedContact.content_json[ci.m_contact_item.id]}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>
                  日時
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{selectedContact.created_at}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-btn @click="showList()">
            一覧に戻る
          </v-btn>
        </template>
        <template v-else>
          <v-data-table
           :headers="headers"
           :items="contacts"
           v-bind:pagination.sync="pagination"
           rows-per-page-text="一度に表示するお問合せ件数"
           :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td v-for="header in headers" :key="header.value">
                <template v-if="header.value == 'created_at'">
                  {{props.item.created_at}}
                </template>
                <a @click="showDetail(props.item)"
                   v-else-if="header.value == 'detail'">
                  詳細
                </a>
                <template v-else>
                  {{props.item.content_json[header.value]}}
                </template>
              </td>
            </template>
          </v-data-table>
          <v-btn @click="download()">
            CSVダウンロード
          </v-btn>
        </template>
      </v-tab-item>
      <v-tab-item id="tab-settings">
        <v-flex md4>
          <v-subheader>お問合せ機能のON/OFF</v-subheader>
        </v-flex>
        <v-flex md4 offset-md1>
          <v-radio-group v-model="site.contact_use" row>
            <v-radio label="ON" :value="true" ></v-radio>
            <v-radio label="OFF" :value="false"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex md4>
          <v-subheader>通知先メールアドレス</v-subheader>
        </v-flex>
        <v-flex md8 offset-md1>
          <v-text-field
             v-model="site.contact_email_address"
             :error-messages="contactEmailErrorMessages">
          </v-text-field>
        </v-flex>
        <v-data-table
           :headers="contactHeaders"
           :items="contactItems"
           hide-actions
           class="elevation-1"
           item-key="id">
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox
                 v-model="props.item.is_used"
                 :disabled="props.item.m_contact_item.is_required !== 0">
              </v-checkbox>
            </td>
            <td>
              <v-checkbox
                 v-model="props.item.is_required"
                 :disabled="props.item.m_contact_item.is_required !== 0">
              </v-checkbox>
            </td>
            <td>{{props.item.m_contact_item.key}}</td>
          </template>
        </v-data-table>
        <v-btn @click="save()" color="success">
          保存
        </v-btn>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</v-content>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { saveAs } from 'file-saver';
import { convert } from 'encoding-japanese';

const successSave = 'お問合せ管理設定の変更を保存しました';
const failSave = '変更された設定の保存時にエラーが発生しました';

export default {
  name: 'Contact',
  data() {
    return {
      tab: '',
      loading: false,
      initiated: false,
      selectedContact: undefined,
      contactEmailErrorMessages: [],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: -1,
      },
      rowsPerPageItems: [50, 100, 1000],
      contactHeaders: [
        {
          text: '使用する',
          value: 'is_used',
          class: this.$style.checkCol,
          align: 'center',
          sortable: false,
        },
        {
          text: '回答必須',
          value: 'is_required',
          class: this.$style.checkCol,
          align: 'center',
          sortable: false,
        },
        { text: '', value: 'key', sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      site: state => state.site,
      contactItems: state => state.site.site_contact_items,
      contacts: state => state.contacts,
      headers: state => state.site.site_contact_items
        .filter(sci => sci.m_contact_item.is_list_header)
        .map(sci => ({ text: sci.m_contact_item.key, value: sci.m_contact_item.id }))
        .concat([
          { text: '日時', value: 'created_at' },
          { text: '', value: 'detail', sortable: false },
        ]),
    }),
  },
  methods: {
    ...mapActions(['postContactItems', 'setContacts', 'showAlert']),
    async save() {
      this.loading = true;
      this.contactEmailErrorMessages = [];
      const result = await this.postContactItems();
      if (result === true) {
        this.showAlert({ message: successSave, type: 'success' });
      } else if (result.contact_email_address) {
        this.contactEmailErrorMessages = [result.contact_email_address];
        this.showAlert({ message: failSave, type: 'error' });
      } else {
        this.showAlert({ message: undefined, type: 'error' });
      }
      this.loading = false;
    },
    async download() {
      const csvHeader = this.contactItems.map(
        ci => ci.m_contact_item.key.replace('"', '""'),
      ).concat('日時').join(',');
      const csvContents = this.contacts.map(
        c => this.contactItems.map(
          (ci) => {
            const col = c.content_json[ci.m_contact_item.id];
            return col ? col.replace('"', '""') : '';
          }).concat(c.created_at).join(','),
      ).join('\r\n');
      const csv = `${csvHeader}\r\n${csvContents}`;
      const sjisCSV = new Uint8Array(convert(csv, {
        to: 'SJIS',
        from: 'AUTO',
        type: 'array',
      }));
      const blob = new Blob([sjisCSV], { type: 'text/csv' });
      saveAs(blob, 'お問合せ履歴.csv');
    },
    async showDetail(contact) {
      this.selectedContact = contact;
    },
    async showList() {
      this.selectedContact = undefined;
    },
  },
  async created() {
    await this.setContacts();
    this.initiated = true;
  },
};
</script>

<style module>
.checkCol {
    width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue